import React from "react";
import { Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaThLarge } from "react-icons/fa";
import { Seller } from "../Components";

const SkyHeights = () => {
  return (
    <>
      <div className="title-bar-wrapper">
        <Container>
          <Row>
            <div className="title">
              <h1>Sky Heights</h1>
            </div>
            <ul className="bread-crumb pull-right">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>-</li>
              <li>Sky Heights</li>
            </ul>
          </Row>
        </Container>
      </div>
      <div className="inner-page-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="why-projects">
                <div className="why-projects-title">
                  <h2>Why Zeeshan Sky Heights?</h2>
                  <div className="why-projects-dec">
                    Project is only 5 minutes from Airport.
                  </div>
                  <div className="why-projects-dec">
                    Project is 2-3 minutes away from vip road Kaikhali Bus Stop.
                  </div>
                  <div className="why-projects-dec">
                    BANK OFFER- HDFC, IDBI, LIC HOUSING FINANCE, Standard
                    Chartered Bank,ICICI Bank and IIFL Finance Limited.
                  </div>
                </div>
              </div>
              <div className="overview-details">
                <h2>Zeeshan Blue Heights Overview</h2>
                <div className="overview-main">
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="overview-single d-flex align-items-center">
                        <div className="overview-icon">
                          <FaThLarge />
                        </div>
                        <div>
                          <span>Project Area</span>
                          <p className="mb-0">0.09 Acres</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="overview-single d-flex align-items-center">
                        <div className="overview-icon">
                          <FaThLarge />
                        </div>
                        <div>
                          <span>Sizes</span>
                          <p className="mb-0">300.00 sq.ft. - 1055.00 sq.ft.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="overview-single d-flex align-items-center">
                        <div className="overview-icon">
                          <FaThLarge />
                        </div>
                        <div>
                          <span>Project Size</span>
                          <p className="mb-0">1 Building - 15 units</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="overview-single d-flex align-items-center">
                        <div className="overview-icon">
                          <FaThLarge />
                        </div>
                        <div>
                          <span>Avg. Price</span>
                          <p className="mb-0">4.00 K/sq.ft</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="overview-single d-flex align-items-center">
                        <div className="overview-icon">
                          <FaThLarge />
                        </div>
                        <div>
                          <span>Possession Startse</span>
                          <p className="mb-0">Mar, 2023</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="overview-single d-flex align-items-center">
                        <div className="overview-icon">
                          <FaThLarge />
                        </div>
                        <div>
                          <span>Configurations</span>
                          <p className="mb-0">1, 2, 3 BHK Apartments</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="group-all-btn">
                    <button>View as 99</button>
                    <button>View as Magic Bricks</button>
                    <button>View as Xyz</button>
                  </div>
                </div>
              </div>
              <div className="overview-details">
                <h2>About Zeeshan Blue Heights</h2>
                <div className="overview-main about-for-project">
                  <p>
                    Sky Heights in Kaikhali, Kolkata is offering trendy homes.
                    The Apartments are under construction and the apartments are
                    available through the builder. Several amenities are present
                    for the community, landscaped garden, Lift, Bike parking,
                    car parking, CCTV Surveillance, Security, Intercom,
                    children's play area and round the clock security amongst
                    others. Kaikhali is one of the top most localities in
                    kolkata and is located in suburb locality of Airport . The
                    area has a great number of apartments for sale with
                    something to suit everyone tastes and budgets ensuring
                    comfort to fulfil everyone needs and requirements.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <Seller />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SkyHeights;
